export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const GET_USERS = 'GET_USERS';
export const GET_QUESTIONS = 'GET_QUESTIONS';